import React from "react";
import "./Common.css";

const beneficiaries = [
  {
    image: "/Images/others.svg",
    title: "Low Birth Weight Babies (0-6 months)",
    color: "rgba(77, 209, 102, 1)"
  },
  {
    image: "/Images/child1.svg",
    title: "Children (6-59 months)",
    color: "rgba(250, 79, 89, 1)"
  },
  {
    image: "/Images/child3.svg",
    title: "Children (5-9 years)",
    color: "#FF9800"
  },
  {
    image: "/Images/child2.svg",
    title: "Adolescents (10-19 years)",
    color: "#26A69A"
  },
  {
    image: "/Images/adolescent.svg",
    title: "Pregnant Women",
    color: "#9C6FBF"
  },
  {
    image: "/Images/pregnant.svg",
    title: "Lactating Women",
    color: "#42A5F5"
  },
  {
    image: "/Images/women.svg",
    title: "Women of Reproductive Age",
    color: "#EC407A"
  }
];

function TargetBeneficiaries() {
  return (
    <section className="target-section">
      <div className="container text-center">

        <span className="badge-title">
          WHO WE SERVE
        </span>

        <h2 className="heading">
          Target Beneficiaries
        </h2>

        <p className="sub-heading">
          Seven key groups ensuring comprehensive <a href="http://"></a>nemia coverage
        </p>

        <div className="row justify-content-center g-3 mt-4">

          {beneficiaries.map((item, index) => (
            <div className="col-lg-3 col-md-3 col-6" key={index}>
              <div className="beneficiary-card" style={{ backgroundColor: item.color }}>
                <img src={item.image} alt="" />
                <h6>{item.title}</h6>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default TargetBeneficiaries;